import React from "react";
import ClayForm, { ClayInput } from "@clayui/form";
import "./DebouncedSearch.css"

interface DebouncedSearchProps {
    placeholder?: string;
    searchValue:string;
    setSearchValue:any
}

const DebouncedSearch: React.FC<DebouncedSearchProps> = ({
    placeholder = "Search",
    searchValue,
    setSearchValue
}) => {
    return (
        <ClayForm.Group className="back-office-custom-search-container mb-0">
            <div className="input-group d-flex align-items-center">
                {/* Custom Search Icon */}
                <div className="input-group-prepend">
                    <span className="custom-search-icon">
                        <svg
                            width="17"
                            height="17"
                            viewBox="0 0 17 17"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                        >
                            <path
                                d="M6.53469 12.2305C4.93602 12.2305 3.58135 11.6752 2.47069 10.5645C1.36002 9.45387 0.804688 8.0992 0.804688 6.50053C0.804688 4.90187 1.36002 3.5472 2.47069 2.43653C3.58135 1.32587 4.93602 0.770199 6.53469 0.769532C8.13335 0.768865 9.48835 1.32453 10.5997 2.43653C11.711 3.54853 12.2664 4.9032 12.2657 6.50053C12.2657 7.1952 12.1427 7.86753 11.8967 8.51753C11.6507 9.16753 11.3274 9.72353 10.9267 10.1855L16.8347 16.0925C16.928 16.1859 16.978 16.3009 16.9847 16.4375C16.9914 16.5742 16.9414 16.6952 16.8347 16.8005C16.728 16.9059 16.6104 16.9592 16.4817 16.9605C16.353 16.9619 16.235 16.9085 16.1277 16.8005L10.2197 10.8925C9.71969 11.3185 9.14469 11.6482 8.49469 11.8815C7.84469 12.1149 7.19135 12.2315 6.53469 12.2315M6.53469 11.2315C7.86135 11.2315 8.98169 10.7749 9.89569 9.86153C10.8097 8.9482 11.2664 7.82787 11.2657 6.50053C11.265 5.1732 10.8084 4.0532 9.89569 3.14053C8.98302 2.22787 7.86302 1.7712 6.53569 1.77053C5.20835 1.76987 4.08802 2.22653 3.17469 3.14053C2.26135 4.05453 1.80469 5.17453 1.80469 6.50053C1.80469 7.82653 2.26135 8.94653 3.17469 9.86053C4.08802 10.7745 5.20802 11.2312 6.53469 11.2305"
                                fill="#003764"
                            />
                        </svg>
                    </span>
                </div>

                {/* Search Input */}
                <ClayInput
                    type="text"
                    className="custom-search-input"
                    placeholder={placeholder}
                    value={searchValue}
                    onChange={(e) => setSearchValue(e.target.value.trimStart())}
                />
            </div>
        </ClayForm.Group>
    );
};

export default DebouncedSearch;
